import PDMPlpSOPDeatils from "@tw/product-discovery-merchandizing-cra/lib/plp/details/details-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMPlpSOPDeatils.domainName = "product-discovery";

export default PageWrapper(PDMPlpSOPDeatils);
